import { Popover, Slider } from 'antd';
import Dropdown from 'antd/lib/dropdown';
import { FormComponentProps } from 'antd/lib/form';
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import * as React from 'react';
import withStyles from 'react-jss';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import {
  fetchAllData,
  fetchGridData,
  getAllDataResetFilter,
  getAllDataSetFilter,
  getAllDataSetSortByFilter,
  setGridFiltersRange,
  setSearchFilterValues,
} from 'src/actions/discoverRatesActions';
import { getPorts } from 'src/api/containerTracking';
import { fetchModeBasedSearchFilters, saveGridSearchHistory } from 'src/api/discoverRates';
import AirModeIcon from 'src/components/common/icons/AirModeIcon';
import FCLModeIconBlack from 'src/components/common/icons/FCLModeIconBlack';
import LCLModeIcon from 'src/components/common/icons/LCLModeIcon';
import RoadModeIconBlack from 'src/components/common/icons/RoadModeIconBlack';
import TrailerModeIconBlack from 'src/components/common/icons/TrailerModeIconBlack';
import { BasicObject, CargoList, ContainerList, PortOrLocation, Ports } from 'src/components/common/Types/CommonTypes';
import withRateDigitisationMasterData from 'src/components/hoc/withRateDigitisationMasterData';
import { Button, Checkbox, Col, Form, Icon, Menu, Row, Select, Spin, Tooltip } from 'src/Library/AntdLibComponents';
import { renderInputNumber, renderPortDropdownOptionsWithCountry, renderPortOptionWithFlag } from 'src/Library/Common';
import { InquiryModes, UserRole } from 'src/Library/Constants';
import { equal, sleep } from 'src/Library/Helper';
import { StylesProps, Weight } from 'src/Library/Types';
import { useGenericState } from 'src/Library/UseGenericState';
import { getDiscoverRatesRoute } from 'src/routing/utils';
import { EventCategories, sendEvent } from 'src/utils/gaService';
import { arrayToObject } from 'src/utils/utils';
import { useDebounce } from '../../../hooks/useDebounce';
import { SEConsignorAddress } from '../shipment-execution/SE.interfaces';
import { DiscoverRatesSearchBarStyles } from './DiscoverRatesSearchBar.styles';
import { tokens } from 'src/design-system';
import DiscoverRatesServicesFilterDetailsModal from './DiscoverRatesServicesFilterDetailsModal';
import {
  directServices,
  FFModes,
  getDiscoverSearchBarMargin,
  getFormItemClassName,
  getGAEventCategory,
  GridView,
  groupRadiusUnitMap,
  modeWiseStuffingDestuffingServices,
  removeTrailingZero,
  savedInLocalStorage,
  searchOrginDestinationType,
  shippingModes
} from './DiscoverRateUtils';
import { DiscoverRatesUnitMap, GridPorts } from './TypesInDiscoverRates/DiscoverRatesCommon';
import { FetchedFilters } from './TypesInDiscoverRates/FetchedFilters';
import { FreightPrice } from './TypesInDiscoverRates/FreightPrice';
import { SearchFilters } from './TypesInDiscoverRates/SearchFilters';
import { SelectedFilters } from './TypesInDiscoverRates/SelectedFilters';
import { TransitDays } from './TypesInDiscoverRates/TransitDays';
interface DiscoverRateSearchBarProps
  extends FormComponentProps,
  StylesProps<ReturnType<typeof DiscoverRatesSearchBarStyles>> {
  cargoList: CargoList[];
  cargoTypeList: BasicObject[];
  containerList: ContainerList[];
  setSearchFilterValues: (e: Partial<SearchFilters>) => void;
  searchFilters: SearchFilters & { containerCount };
  fetchAllData: ({}: {isSearch?: boolean, resetFreight?: boolean, fromURL?: boolean}) => {};
  isDiscoverPage: boolean;
  getAllDataResetFilter: (apiCall?: boolean, fromURL?: boolean) => void;
  getAllDataSetSortByFilter: (val, apiCall?: boolean) => void;
  showDiscoverBuyRates: boolean;
  showDiscoverSellRates: boolean;
  orgType: string;
  viewType: string;
  getAllDataSetFilter: (val: Partial<SelectedFilters>, apiCall?: boolean) => void;
  fetchGridData: (isPrimary?: boolean) => void;
  selectedFilters: SelectedFilters;
  setGridFiltersRange: (val) => void;
  gridFreightRange: FreightPrice;
  gridTransitRange: TransitDays;
  gridPorts: GridPorts;
  isSharingModule: boolean;
  inquiryTypeToIncoterms: { EXPORT: string[], IMPORT: string[] };
  userRole: UserRole;
  shipperTeamId: number;
  fetchedFilters: FetchedFilters;
  discoverRatesMaps: DiscoverRatesUnitMap;
  setMode: (mode: InquiryModes) => void;
  discoverRatesPrefillData: any;
  disableRateDiscoveryServicesLinking: boolean;
  stuffingAddressesList: SEConsignorAddress[];
  destuffingAddressesList: SEConsignorAddress[];
  rateMasterData: any;
  defaultDistanceUnit?: 'mi' | 'km';
  setIntial: () => void;
  showRoadInsteadDomestic?: boolean;
}

interface StateProps {
  ports: Ports[];
  isSearching: boolean;
  isLoading: boolean;
  searchTerm: string;
  portType: string;
  polSelected?: PortOrLocation;
  podSelected?: PortOrLocation;
  isVolumeInputSelected: boolean;
  isServicesFilterDetailsModalVisible: boolean;
  stuffingAddresses: SEConsignorAddress[];
  deStuffingAddresses: SEConsignorAddress[];
  isFetchingAddresses?: boolean;
  // originServices and destinationServices are all the services present in incoterm
  // originStuffingServices and destinationDestuffingServices are services where stuffing destuffing details are required
  originServices?: string[];
  destinationServices: string[];
  originStuffingServices?: string[];
  destinationDestuffingServices: string[];
  serviceDetails?: {
    originServices?: string[];
    stuffingType?: string;
    stuffingLocationId?: string;
    stuffingWeight?: Weight;
    destinationServices?: string[];
    destuffingType?: string;
    destuffingLocationId?: string;
    destuffingWeight?: Weight;
  };
  uniqueOriginCity: PortOrLocation[];
  uniqueDestinationCity: PortOrLocation[];
  originGroupRadiusPopupBoxVisible: boolean;
  destinationGroupRadiusPopupBoxVisible: boolean;
  originGeoRadius: { value: number; unit: 'km' | 'mi' };
  destinationGeoRadius: { value: number; unit: 'km' | 'mi' };
  isInitial: boolean;
  modeBasedFilterOptions: {
    originList: PortOrLocation[];
    destinationList: PortOrLocation[];
    incotermList: any;
    containerList: any[];
    vehicleTypeList: any[];
    cargoList: any[];
  },
  isModeBasedFilterOptionsLoading: boolean;
  prefillModeBasedFilterValues: boolean;
  isAllPortsOrCiti:boolean,
  isOriginPortsOrCities:boolean,
  isDestinationPortsOrCities:boolean

}

interface Dimensions { length: number, breadth: number, height: number }

const { useState, useEffect } = React;
const { FCL, LCL, AIRCARGO, DOMESTIC, TRAILER, RPTL } = InquiryModes;

const DiscoverRateSearchBar = (props: DiscoverRateSearchBarProps): React.ReactElement => {
  const history = useHistory();

  const {
    classes,
    form,
    cargoList,
    containerList,
    setSearchFilterValues,
    searchFilters,
    fetchAllData,
    isDiscoverPage,
    getAllDataResetFilter,
    getAllDataSetSortByFilter,
    showDiscoverBuyRates,
    showDiscoverSellRates,
    orgType,
    viewType,
    fetchGridData,
    getAllDataSetFilter,
    selectedFilters,
    setGridFiltersRange,
    gridTransitRange,
    gridFreightRange,
    gridPorts,
    isSharingModule,
    inquiryTypeToIncoterms,
    fetchedFilters,
    discoverRatesMaps,
    setMode,
    discoverRatesPrefillData,
    disableRateDiscoveryServicesLinking,
    stuffingAddressesList,
    destuffingAddressesList,
    rateMasterData,
    defaultDistanceUnit,
    setIntial,
    showRoadInsteadDomestic
  } = props;

  const initialState = {
    ports: [] as Ports[],
    isSearching: false,
    isLoading: false,
    searchTerm: '',
    portType: 'pol',
    polSelected: {} as PortOrLocation,
    podSelected: {} as PortOrLocation,
    isVolumeInputSelected: !searchFilters?.length,
    isServicesFilterDetailsModalVisible: false,
    stuffingAddresses: [] as SEConsignorAddress[],
    deStuffingAddresses: [] as SEConsignorAddress[],
    originServices: [] as string[],
    destinationServices: [] as string[],
    originStuffingServices: [] as string[],
    destinationDestuffingServices: [] as string[],
    serviceDetails: {},
    uniqueOriginCity: [],
    uniqueDestinationCity: [],
    originGroupRadiusPopupBoxVisible: false,
    destinationGroupRadiusPopupBoxVisible: false,
    originGeoRadius: { value: 0, unit: defaultDistanceUnit || 'km' },
    destinationGeoRadius: { value: 0, unit: defaultDistanceUnit || 'km' },
    isInitial: true,
    modeBasedFilterOptions: {
      originList: [],
      destinationList: [],
      incotermList: {},
      containerList: [],
      vehicleTypeList: [],
      cargoList: []
    } as any,
    isModeBasedFilterOptionsLoading: true,
    prefillModeBasedFilterValues: false,
    isFetchingAddresses: false,
    isInitialSearchBarMount: true,
    isAllPortsOrCiti:false,
    isOriginPortsOrCities:false,
    isDestinationPortsOrCities:false,
    includeExpiredRates: false
  }

  const [state, setState] = useGenericState<typeof initialState>(initialState);

  const {
    ports,
    isSearching,
    isLoading,
    searchTerm,
    portType,
    polSelected,
    podSelected,
    isVolumeInputSelected,
    isServicesFilterDetailsModalVisible,
    stuffingAddresses,
    deStuffingAddresses,
    isFetchingAddresses,
    originServices,
    destinationServices,
    originStuffingServices,
    destinationDestuffingServices,
    serviceDetails,
    uniqueDestinationCity,
    uniqueOriginCity,
    originGroupRadiusPopupBoxVisible,
    destinationGroupRadiusPopupBoxVisible,
    originGeoRadius,
    destinationGeoRadius,
    isInitial,
    modeBasedFilterOptions,
    isModeBasedFilterOptionsLoading,
    prefillModeBasedFilterValues,
    isInitialSearchBarMount,
    isAllPortsOrCiti,
    isOriginPortsOrCities,
    isDestinationPortsOrCities
  } = state;

  // const defaultPol = {
  //   code: 'INNSA',
  //   country: 'India',
  //   countryCode: 'IND',
  //   countryName: 'India',
  //   id: '3152',
  //   flagS3Link:
  //     'https://shipsy-public-assets.s3-us-west-2.amazonaws.com/shipper-dashboard/country-flags/in.png',
  //   name: 'Nhava Sheva',
  //   type: 'WET',
  // };

  // const defaultPod = {
  //   code: 'AEJEA',
  //   country: 'United Arab Emirates',
  //   countryCode: 'ARE',
  //   countryName: 'United Arab Emirates',
  //   id: '2843',
  //   flagS3Link:
  //     'https://shipsy-public-assets.s3-us-west-2.amazonaws.com/shipper-dashboard/country-flags/ae.png',
  //   name: 'Jebel Ali',
  //   type: 'WET',
  // };

  const defaultContainerList = {
    key: {
      type: 'STANDARD',
      size: "20'",
    },
    label: {
      type: 'Standard',
      size: "20'",
    },
  };

  const defaultCargoList = {
    key: {
      cargo: 'GENERAL',
      product: 'GENERAL_DRY_GOODS',
    },
    label: {
      cargo: 'General',
      product: 'General Dry Goods',
    },
  };

  const defaultDomesticCargoList = {
    key: {
      cargo: 'GENERAL',
      product: 'ALL',
    },
    label: {
      cargo: 'General',
      product: 'All',
    },
  };
  
  const defaultVehicle = 'OPEN TRAILER';

  const isLandingPage = location.pathname?.includes('discover-rates') && orgType === 'SHIPPER' && !discoverRatesPrefillData;

  const localStorageSavedValues = JSON.parse(
    localStorage.getItem(
      `${showDiscoverBuyRates && viewType !== GridView.LIST && orgType === 'FF'
        ? savedInLocalStorage.SAVED_GRID_SEARCH
        : savedInLocalStorage.SAVED_SEARCH
      }`
    ) || '[]'
  );
  const debouncedSearchTerm = useDebounce(searchTerm, 300);
  const mode = orgType !== 'SHIPPER' ? FCL : form.getFieldValue('mode');
  const isModeTypeRoadDomestic = mode === DOMESTIC;
  const isModeTypeTrailer = mode === TRAILER;
  const isModeTypeRPTL = mode === RPTL;

  useEffect(() => {
    // handleSearchBarMount();
    if (!showDiscoverBuyRates) setSearchFilterValues({ view: 'SELL' });
    if (showDiscoverBuyRates && viewType !== GridView.GRID && orgType === 'FF') {
      setSearchFilterValues({ viewType: GridView.LIST });
    }
  }, []);

  useEffect(() => {
    if (mode) {
      handleModeBasedSearchFilterOptions();
    }
  }, [mode])

  useEffect(() => {
    setState({isVolumeInputSelected: !searchFilters?.length,})
  }, [searchFilters?.length])
  
  // useEffect(() => {
  //   (orgType === 'SHIPPER' && disableRateDiscoveryServicesLinking) && setState({ stuffingAddresses: stuffingAddressesList });
  // }, [stuffingAddressesList]);

  // useEffect(() => {
  //   (orgType === 'SHIPPER' && disableRateDiscoveryServicesLinking) && setState({ deStuffingAddresses: destuffingAddressesList });
  // }, [destuffingAddressesList]);

  // useEffect(() => {
  //   if(polSelected?.id && podSelected?.id) { 
  //     searchPorts(debouncedSearchTerm);
  //    }
  // }, [debouncedSearchTerm, portType]);
  
  useEffect(() => {
    const saved = discoverRatesPrefillData ?? (localStorageSavedValues ? (localStorageSavedValues[0] || {}) : {});
    if (saved.incoterm && saved.movementType && isEmpty(serviceDetails) &&
    (!selectedFilters?.originServices || !selectedFilters?.destinationServices)) {
      const { originServices, destinationServices } = fetchedFilters;
      getAllDataSetFilter({
        originServices: directServices.filter((service) => originServices?.includes(service)),
        destinationServices: directServices.filter((service) => destinationServices?.includes(service))
      }, false);
    }
    if (saved?.pod?.id === '-1'||saved?.pod?.id === '0'){
      setState({
        isDestinationPortsOrCities:true
      })
    }
    else if (saved?.pol?.id === '-1'||saved?.pol?.id === '0'){
      setState({
        isOriginPortsOrCities:true
      })
    }
  }, [fetchedFilters])

  useEffect(() => {
    if (!searchFilters.fromGridView) {
      const saved = discoverRatesPrefillData ?? (localStorageSavedValues ? (localStorageSavedValues[0] || {}) : {});
      const initialPOL = saved.pol || modeBasedFilterOptions.originList?.[0];
      const initialPOD = saved.pod || modeBasedFilterOptions.destinationList?.[0];
      if (!searchFilters.fromGridView && isDiscoverPage && !history?.location?.state?.fromPopUp) {
        onListViewChange(saved);
      } else {
        setState({
          polSelected: initialPOL,
          podSelected: initialPOD,
        });
      }

      // form.setFieldsValue({
      //   mode: orgType !== 'SHIPPER' ? FCL : saved.mode || FCL,
      //   ContainerList: JSON.stringify(saved.container?.label ? saved.container : modeBasedFilterOptions.containerList?.[0]),
      //   polId: { key: initialPOL?.id, label: renderPortOption(initialPOL) },
      //   podId: { key: initialPOD?.id, label: renderPortOption(initialPOD) },
      // }, () => {
      //   const filteredContainer = getCargoFromContainer();
      //   form.setFieldsValue({
      //     CargoList: JSON.stringify(saved.cargo || filteredContainer?.[0]),
      //   })
      // });
    }
  }, [viewType]);

  useEffect(() => {
    if (!isInitial) {
      handleSearch();
      setState({
        originGroupRadiusPopupBoxVisible: false,
        destinationGroupRadiusPopupBoxVisible: false,
      })
    }
  }, [originGeoRadius, destinationGeoRadius])

  const renderModeTextWithIcon = (mode, stroke) => {
    return <>
    <div className={classes.modeIcon}>
      {renderModeIcon(shippingModes[mode], stroke)}
      </div>
      <span style={{ marginLeft: '8px' }}></span>{mode}
    </>
  }

  // Initial search by search bar that is on the left side of the landing page, on the top later on
  const handleSearchBarMount = (modeBasedFilterData, cb?) => {    
    const saved = discoverRatesPrefillData ?? (localStorageSavedValues ? (localStorageSavedValues[0] || {}) : {});
    const prefillMode = orgType !== 'SHIPPER' ? (form.getFieldValue('mode') || FCL) : ((saved.mode && isInitialSearchBarMount) ? saved.mode : form.getFieldValue('mode') || FCL);
    const prefillPol = (saved.pol && isInitialSearchBarMount) ? saved.pol : (modeBasedFilterData.originCityList?.[0] || modeBasedFilterData.originList?.[0]);
    const prefillPod = (saved.pod && isInitialSearchBarMount) ? saved.pod : (modeBasedFilterData.destinationCityList?.[0] || modeBasedFilterData.destinationList?.[0]);
    const prefillCargo = (saved.cargo && isInitialSearchBarMount) ? 
    JSON.stringify(saved.cargo) :  
    JSON.stringify(
      modeBasedFilterData?.cargoList?.[0] ? {key: modeBasedFilterData?.cargoList?.[0].key, label: modeBasedFilterData?.cargoList?.[0].label} : undefined);
    const prefillContainer = (saved.container?.label && isInitialSearchBarMount)
    ? JSON.stringify(saved.container)
    : JSON.stringify(modeBasedFilterData?.containerList?.[0] ? {key: modeBasedFilterData?.containerList?.[0].key, label: modeBasedFilterData?.containerList?.[0].label} : undefined);
    const prefillVehicle = (prefillMode !== RPTL) ? ((saved.vehicle && isInitialSearchBarMount) ? saved.vehicle : modeBasedFilterData?.vehicleTypeList?.[0]?.key) : undefined;
    const prefillIncoterm = (saved.incoterm && isInitialSearchBarMount) ? saved.incoterm : undefined;
    const prefillMovementType = (saved.movementType && isInitialSearchBarMount) ? saved.movementType : undefined;
    //use this
    if (isInitialSearchBarMount) {
      setSearchFilterValues({
        mode: saved.mode || form.getFieldValue('mode'),
        ...(!isGridViewVisible() && {
          pol: prefillPol,
          pod: prefillPod,
        }),
        container: prefillContainer,
        cargo: prefillCargo,
        ...(prefillMode !== RPTL && { vehicle: prefillVehicle }),
        includeExpiredRates: isLandingPage ? false : saved?.includeExpiredRates || false,
        incoterm: prefillIncoterm,
        movementType: prefillMovementType,
        shipperTeamId: saved.shipperTeamId || undefined,
        grossWeight: saved.grossWeight || undefined,
        totalVolume: saved.totalVolume || undefined,
        length: saved.length || undefined,
        breadth: saved.breadth || undefined,
        height: saved.height || undefined,
        count: saved.count || undefined,
        dimensionUnit: saved.dimensionUnit || undefined,
        totalVolumetricWeight: saved.totalVolumetricWeight || undefined,
        originCity: saved.originCity || prefillPol?.city || undefined,
        originState: saved.originState || prefillPol?.state || undefined,
        destinationCity: saved.destinationCity || prefillPod?.city || undefined,
        destinationState: saved.destinationState || prefillPod?.state || undefined,
        originCountryId: saved.originCountryId || prefillPol?.countryId || undefined,
        destinationCountryId: saved.destinationCountryId || prefillPod?.countryId || undefined
      });
      if (discoverRatesPrefillData) {
        addToLocalStorage({
          mode: prefillMode,
          container: prefillContainer,
          cargo: prefillCargo,
          includeExpiredRates: saved?.includeExpiredRates || false,
          pol: prefillPol,
          pod: prefillPod,
          incoterm: prefillIncoterm,
          vehicle: prefillVehicle,
          movementType: prefillMovementType,
          shipperTeamId: saved.shipperTeamId || undefined,
          grossWeight: saved.grossWeight || undefined,
          totalVolume: saved.totalVolume || undefined,
          length: saved.length || undefined,
          breadth: saved.breadth || undefined,
          height: saved.height || undefined,
          count: saved.count || undefined,
          dimensionUnit: saved.dimensionUnit || undefined,
          totalVolumetricWeight: saved.totalVolumetricWeight || undefined,
          originCity: saved.originCity || prefillPol?.city || undefined,
          originState: saved.originState || prefillPol?.state || undefined,
          destinationCity: saved.destinationCity || prefillPod?.city || undefined,
          destinationState: saved.destinationState || prefillPod?.state || undefined,
          originCountryId: saved.originCountryId || prefillPol?.countryId || undefined,
          destinationCountryId: saved.destinationCountryId || prefillPod?.countryId || undefined
        });
      }
    }
    setState({
      polSelected: prefillPol,
      podSelected: prefillPod,
    });
    form.setFieldsValue({
      mode: prefillMode,
      ContainerList: prefillContainer,
      CargoList: prefillCargo,
      polId: { key: prefillPol?.id, label: renderPortOption(prefillPol) },
      podId: { key: prefillPod?.id, label: renderPortOption(prefillPod) },
      vehicle: prefillVehicle,
      includeExpiredRates: saved?.includeExpiredRates || false
    });
    if (isInitialSearchBarMount) {
      fetchAllData({isSearch: false, resetFreight: false, fromURL: true});
      setState({
        isInitialSearchBarMount: false
      })
    }
    if (typeof cb === 'function') {
      cb();
    }
      if (prefillPol.id ==='-1'|| prefillPol.id ==='0'){
        setState({
          isOriginPortsOrCities:true
        })
      }
      if (prefillPod.id ==='-1'|| prefillPod.id ==='0'){
        setState({
          isDestinationPortsOrCities:true
        })
      }
  }

  const handleModeChange = (val: InquiryModes) => {
    setMode && setMode(val);
    const isAir = val === AIRCARGO;
    const isRoadDomestic = val === DOMESTIC;
    const isTrailer = val === TRAILER;
    const isRPTL = val === RPTL;
    // Clear vehicle when switching to RPTL mode
    if (isRPTL && searchFilters.vehicle) {
      setSearchFilterValues({ vehicle: undefined });
    }
    const saved = localStorageSavedValues ? localStorageSavedValues.find(item => item.mode === val) || {} : {};
    // const initialPOL = saved.pol || (isAir ? defaultPolAir : (isRoadDomestic || isTrailer) ? uniqueOriginCity[0] : modeBasedFilterOptions.originList?.[0]);
    // const initialPOD = saved.pod || (isAir ? defaultPodAir : isRoadDomestic ? uniqueDestinationCity[uniqueDestinationCity?.length - 1] : modeBasedFilterOptions.destinationList?.[0]);
    // const cargoList = (isRoadDomestic || isTrailer) ? defaultDomesticCargoList : defaultCargoList;
    // form.setFieldsValue({
    //   polId: { key: initialPOL?.id, label: renderPortOption(initialPOL) },
    //   podId: { key: initialPOD?.id, label: renderPortOption(initialPOD) },
    //   // CargoList: JSON.stringify(saved?.cargo || cargoList),
    // });
    // if (isRoadDomestic || isTrailer) {
    //   form.setFieldsValue({
    //     vehicle: saved.vehicle || defaultVehicle,
    //   });
    // }
    // setState({ polSelected: initialPOL, podSelected: initialPOD });
  }

  const isGridViewVisible = () => {
    return orgType === 'FF' && showDiscoverBuyRates && viewType === GridView.GRID;
  };

  const renderMode = (): React.ReactElement => {
    const modes = orgType === 'SHIPPER' ? shippingModes : FFModes;
    const colSpan = isModeTypeTrailer ? 3 : 2;
    return (
      <Col
        span={colSpan}
        className={
          isLandingPage
            ? classNames(classes.landingPageOptions, classes.landingPageMode)
            : classes.modeDiv
        }
      >
        <div
          style={{
            fontSize: '10px',
            width: isLandingPage ? '34%' : 'auto',
          }}
        >
          Mode
        </div>
        <Form.Item
          className={getFormItemClassName(isLandingPage, classes)}
        >
          {form.getFieldDecorator(`mode`, {
            rules: [{ required: true, message: `mode is required` }],
            initialValue: (orgType === 'SHIPPER' && searchFilters?.mode) ? searchFilters?.mode : FCL,
          })(
            <Select
              mode="default"
              className={classNames(classes.selectMode, !isLandingPage && classes.disoverPageDropdown)}
              dropdownClassName={classes.modeDropdown}
              showSearch
              showArrow={false}
              dropdownMatchSelectWidth={false}
              placeholder='Select mode'
              onChange={handleModeChange}
              optionLabelProp="data-value"
            >
              {Object.keys(modes).map((item) => {
                return (
                  <Select.Option key={modes[item]} data-value={renderModeTextWithIcon(item, isLandingPage ? '' : '#fff')} >
                    {renderModeTextWithIcon(item, '')}
                  </Select.Option>
                );
              })}
            </Select>
          )}
        </Form.Item>
      </Col>
    );
  };
  

 
const loadAddresses = (data) => {
  const stuffingAddresses = [
    ...(data?.originCityList?.filter((item) => !!item.address) || []),
    ...(data?.originStateList?.filter((item) => !!item.address) || [])
  ];
  const deStuffingAddresses = [
    ...(data?.destinationCityList?.filter((item) => !!item.address) || []),
    ...(data?.destinationStateList?.filter((item) => !!item.address) || [])
  ];
  ['stuffing', 'destuffing'].forEach((type) => {
    const addressList = type === 'stuffing' ? stuffingAddresses : deStuffingAddresses;
    const stateObjKey = type === 'stuffing' ? 'uniqueOriginCity' : 'uniqueDestinationCity';
     
    if (addressList?.length) {
      const cityObj = {};
      addressList.forEach(item => {
        // Handle city addresses
        if (item?.city && (item?.countryId || item?.country_id) && !cityObj[item?.city]) {
          cityObj[item.city] = {
            id: item.id,
            name: item.countryName || item.country_name,
            code: item.city,
            country: item.countryName || item.country_name,
            countryId: item.countryId || item.country_id,
            countryName: item.countryName || item.country_name,
            flagS3Link: item.flagS3Link || item.flag_s3_link,
            type: 'ADDRESS',
            ...(item.state && { state: item.state }),
          };
        }
        
        // Handle state addresses - only process items that have state but no city (pure state entries)
        if (item?.state && !item?.city && (item?.countryId || item?.country_id) && !cityObj[item?.state]) {
          cityObj[item.state] = {
            id: item.id,
            name: item.countryName || item.country_name,
            code: item.state,
            country: item.countryName || item.country_name,
            countryId: item.countryId || item.country_id,
            countryName: item.countryName || item.country_name,
            flagS3Link: item.flagS3Link || item.flag_s3_link,
            type: 'ADDRESS',
          };
        }
      });
      setState({
        [stateObjKey]: Object.values(cityObj),
      });
    }
  });
  
  setState({ stuffingAddresses, deStuffingAddresses, isFetchingAddresses: false });
};

  const renderModeIcon = (optionMode: InquiryModes, strokeColor: string) => {
    switch (optionMode) {
      case AIRCARGO:
        return <AirModeIcon strokeColor={strokeColor}/>;
      case LCL:
        return <LCLModeIcon strokeColor={strokeColor}/>;
      case DOMESTIC: 
        return <RoadModeIconBlack strokeColor={strokeColor}/>;
      case TRAILER: 
        return <TrailerModeIconBlack strokeColor={strokeColor} fill={'#666'}/>;
      case RPTL:
        return <RoadModeIconBlack strokeColor={strokeColor}/>;
      default:
        return <FCLModeIconBlack strokeColor={strokeColor}/>;
    }
  }

  const onListViewChange = async (saved) => {
    // await setSearchFilterValues({
    //   pol: saved.pol || modeBasedFilterOptions.originList?.[0],
    //   pod: saved.pod || modeBasedFilterOptions.destinationList?.[0],
    //   container: saved.container
    //     ? JSON.stringify(saved.container)
    //     : JSON.stringify(defaultContainerList),
    //   cargo: saved.cargo ? JSON.stringify(saved.cargo) : JSON.stringify(defaultCargoList),
    // });
    if (viewType === GridView.LIST) {
      getAllDataResetFilter(false);
      if (modeBasedFilterOptions?.originList?.length) {
        handleSearchBarMount(modeBasedFilterOptions, fetchAllData({isSearch: false, resetFreight: false, fromURL: true}));
      }

    }
  };

  const searchPorts = async (queryString: string): Promise<void> => {
    const isAir = (form.getFieldValue('mode')??searchFilters?.mode??FCL) === AIRCARGO;
    let ports: Ports[] = [];
    setState({ isSearching: true });
    const response = await getPorts({
      queryString,
      type: isAir ? 'AIR' : ['DRY', 'WET'],
      searchByCountryName: true
    });
    if (response.isSuccess) {
      ports = response.data.map((el) => ({
        id: el.dbId,
        ...el,
      }));
    } else {
      ports = [];
    }
    setState({ ports, isSearching: false });
  };

  const renderPortOption = (label): React.ReactElement => {
    if (label.filterType && label.filterType === 'portGroup'){
        return <div className={classes.selectedValueStyle}>
            <div>{label.group_name}</div>
            <div className={classes.countryName}>Port Group</div>
        </div>
    }
    if (label?.state) {
      const countryDisplay = label.countryName || label.country_name;
      return (
        <div className={classes.selectedValueStyle} style={{ flexDirection: 'column', alignItems: 'flex-start' }}>
          <span className={classes.selectedCityValue}>{label?.code}</span>
          <span className={classes.countryName} style={{ marginLeft: 0 }}>
            {label.state}{countryDisplay ? `, ${countryDisplay}` : ''}
          </span>
        </div>
      );
    }
    return renderPortOptionWithFlag(label, {
      countryName: classes.countryName,
      selectedValueStyle: classes.selectedValueStyle,
      countryCode: classes.selectedCityValue,
    });
  };
   const [isAllPortsOrCities, setIsAllPortsOrCities] = useState(isAllPortsOrCiti);
  const renderPortsSearch = ({label, title, isOrigin = false}): React.ReactElement => {
    let optionsList: PortOrLocation[] = isOrigin ? modeBasedFilterOptions.originList : modeBasedFilterOptions.destinationList;
    const portGroups = optionsList.filter((data) => data.filterType === 'portGroup')


    if (isModeTypeRoadDomestic || isModeTypeTrailer || isModeTypeRPTL) {
      optionsList = isOrigin ? uniqueOriginCity : uniqueDestinationCity;
    };
    if (isModeTypeTrailer) {
      const ports = isOrigin ? modeBasedFilterOptions.originList.filter((data) => data.filterType !== 'portGroup') 
                            : modeBasedFilterOptions.destinationList.filter((data) => data.filterType !== 'portGroup');
      optionsList = [...optionsList, ...ports];
    }
    if (isModeTypeRoadDomestic || isModeTypeTrailer || isModeTypeRPTL){
         //show port groups at last in the dropdown of Domestic and Trailer
         optionsList = [...optionsList, ...portGroups]
         //Make sure optionsList contains unique ids
         optionsList = Array.from(new Map(optionsList.map(item => [item.id, item])).values())
    }


    const initialValue = searchFilters === mode ? searchFilters?.[title] && {
      key: searchFilters[title].id,
      label: renderPortOption(searchFilters[title]),
    } : undefined
 
    // if(title ==='origin'){
    //   setIsAllPortsOrCities(isOriginPortsOrCities)
    // }
    // else{
    //   setIsAllPortsOrCities(isDestinationPortsOrCities)
    // }
    return (
      <Col
        span={isSharingModule ? 4 : 5}
        className={isLandingPage ? classes.landingPageOptions : classes.optionsRelativeDiv}
      >
        {renderSearchTitle(label)}
        <Form.Item
          className={getFormItemClassName(isLandingPage, classes)}
        >
          {form.getFieldDecorator(`${title}Id`, {
            rules: [{ required: true, message: `${label} is required` }],
            initialValue,
          })(
            <Select
              disabled={isModeBasedFilterOptionsLoading}
              mode="default"
              className={classes.select}
              showArrow={false}
              dropdownClassName={classes.dropdown}
              optionLabelProp={'data-value'}
              showSearch
              labelInValue
              dropdownMatchSelectWidth={false}
              // onSearch={(e) => handleCityPortTrailerModeSearch(e, isOrigin)}
              // onFocus={() => {
              //   handlePortSearchOnFocus(title, isOrigin)
              // }}
              placeholder={label}
              onChange={(val) => {handleOriginDestinationChange(val, title, optionsList)
                setIsAllPortsOrCities(handleOriginDestinationChange(val, title, optionsList))
              }}
              dropdownRender={(menu) =>
                isSearching ? <Spin style={{ margin: '20px 0 20px 45%' }} /> : menu
              }
              filterOption={handlePortOptionFilter}
            >
              {optionsList?.map((item) => {
                  return (
                    <Select.Option key={item.id} data-value={renderPortOption(item)}>
                      {renderPortDropdownOptionsWithCountry(item, {
                        dropdownDiv: classes.dropdownDiv,
                        countryCode: classes.countryCode,
                        dryPort: classes.dryPort,
                      }, isModeTypeTrailer)}
                    </Select.Option>
                  );
                })}
            </Select>
          )}
        </Form.Item>
        {!isLandingPage ? renderGroupPortsCities(['pol', 'origin'].includes(title) ? 'origin' : 'destination',isAllPortsOrCities) : null}
      </Col>
    );
  };

  const setPortFilter = (val, title, options = []): void => {
  const portsList = Array.isArray(options) ? arrayToObject(options, 'id') : {};
  let value;
  if (val?.key && portsList[val.key]) {
    value = portsList[val.key];
  }
  if (title === 'pol') {
    setState({ polSelected: value });
  } else if (title === 'pod') {
    setState({ podSelected: value });
  }
};

  const setCityFilter = (val, title, options): void => {
  const cityObj = arrayToObject(title === 'pol' ? uniqueOriginCity : uniqueDestinationCity, 'id');
  let value;
  if (val?.key && cityObj[val.key]) {
    value = cityObj[val.key];
  } 
  // When isModeTypeRoadDomestic -> Set filter for both city and port group
  if ((isModeTypeTrailer || isModeTypeRoadDomestic || isModeTypeRPTL) && !value) {
    setPortFilter(val, title, options);
    return;
  }
  if (title === 'pol') {
    setState({ polSelected: value });
  } else if (title === 'pod') {
    setState({ podSelected: value });
  }
};

  const handleCityPortTrailerModeSearch = (e, isStuffing = false) => {
    if (isModeTypeRoadDomestic || isModeTypeRPTL || (isModeTypeTrailer && isStuffing)) return null;
    setState({ searchTerm: e });
    return null;
  }

  const handlePortSearchOnFocus = (title, isStuffing = false) => {
    if (isModeTypeRoadDomestic || isModeTypeRPTL || (isModeTypeTrailer && isStuffing) ) {
      return null;
    }
    setState({ portType: title, searchTerm: '' })
    return null;
  }

  const handlePortOptionFilter = (input, option) => {
    const searchQuery = typeof input === 'string' ? input.toLowerCase() : '';
    const getText = (node) => {
      const val = node?.props?.children;
      if (typeof val === 'string') return val;
      if (Array.isArray(val)) return val.map((v) => (typeof v === 'string' ? v : '')).join('');
      return '';
    };
    const safeLower = (str) => (typeof str === 'string' ? str.toLowerCase() : '');
    const dataValueChildren = option?.props?.['data-value']?.props?.children;
    const c = Array.isArray(dataValueChildren) ? dataValueChildren : [];
    const portGroupName = safeLower(getText(c[0]));
    const portCode = safeLower(getText(c[1]));
    const name = safeLower(getText(c[2]));
    return portCode?.includes(searchQuery) || name?.includes(searchQuery) || portGroupName?.includes(searchQuery);
  }

  const handleOriginDestinationChange = (val, title, options) => {

  const selectedItem = options.find(item => item.id === val?.key);
  
  if (selectedItem) {
    // Update the appropriate state based on title
    if (title === 'pol') {
      setState({ polSelected: selectedItem });
    } else if (title === 'pod') {
      setState({ podSelected: selectedItem });
    }
  }
  // Handle city/port filtering logic
  if (isModeTypeTrailer || isModeTypeRoadDomestic || isModeTypeRPTL) { 
    setCityFilter(val, title, options);
  } else {
    setPortFilter(val, title, options);
  }
  
  // Return boolean for UI state
  if (val?.key === '-1' || val?.key === '0') {
    return true;
  } else {
    return false;
  }
};

  const renderSearchTitle = (title, showOptional = false): React.ReactElement => {
    return (
      <div
        className={
          isLandingPage
            ? classNames(classes.selectTitleWidth, classes.selectTitle)
            : classes.selectTitle
        }
      >
        {title}{showOptional && <span style={{fontSize: 8, color: '#999'}}>&nbsp;(optional)</span>}
      </div>
    );
  };

  const handleContainerChange = (container) => {
    const cargoList = modeBasedFilterOptions?.cargoList?.filter(item => getCargoFromContainer(container).includes(item.key.cargo));
    // const reeferDefault = {
    //   key: {
    //     cargo: 'REEFER',
    //     product: 'FROZEN_GOODS(-26°C_TO_-18°C)',
    //   },
    //   label: {
    //     cargo: 'Reefer',
    //     product: 'Frozen goods(-26°C to -18°C)',
    //   },
    // };
    form.setFieldsValue({ CargoList: cargoList?.[0] ? JSON.stringify({key: cargoList?.[0]?.key, label: cargoList?.[0]?.label}) : undefined});
  };

  const getContainerCargoColSpan = () => {
    return isGridViewVisible() ? 9 : 4;
  };

  const renderContainerSearch = (title): React.ReactElement => {
    const options = modeBasedFilterOptions?.containerList?.length ? modeBasedFilterOptions?.containerList : [];
    return (
      <Col
        span={isSharingModule ? 3 : getContainerCargoColSpan()}
        className={isLandingPage ? classes.landingPageOptions : classes.optionsDiv}
      >
        {renderSearchTitle(title)}
        <Form.Item
          className={getFormItemClassName(isLandingPage, classes)}
        >
          {form.getFieldDecorator('ContainerList', {
            rules: [{ required: true, message: 'Container is required' }],
            // initialValue: searchFilters.container,
          })(
            <Select
              disabled={isModeBasedFilterOptionsLoading}
              mode="default"
              dropdownClassName={classes.dropdown}
              className={classes.select}
              showArrow={false}
              showSearch
              onChange={(val) => handleContainerChange(val)}
              optionFilterProp="children"
              placeholder={title}
            >
              {options.map((list) => (
                  <Select.Option key={JSON.stringify({ key: list.key, label: list.label })}>
                    {`${list.label.type} - ${list.label.size}`}
                  </Select.Option>
                ))}
            </Select>
          )}
        </Form.Item>
      </Col>
    );
  };

  const renderContainerCount = () => {
    return (
      <Col span={3} className={classes.optionsDiv}>
        {renderSearchTitle('Container Count')}
        <h3 style={{ marginTop: '0.5em' }}>{searchFilters.containerCount || 1}</h3>
      </Col>
    );
  };

  const renderSearchButton = (): React.ReactElement => {
    return (
      <Col
        span={3}
        className={
          isLandingPage
            ? classNames(classes.landingPageOptions, classes.commonSearchButtonStyle)
            : classNames(classes.optionsDiv, classes.commonSearchButtonStyle)
        }
        style={{ marginTop: isLandingPage ? '16px' : 0 }}
      >
        <Button
          className={
            (isServicesFilterDetailsModalVisible || isModeBasedFilterOptionsLoading) ?
              classNames(classes.search, classes.searchDisabled) :
            (isLandingPage ? classNames(classes.search, classes.landingPageSearch) : classes.search)
          }
          style={{
            color: '#FFFFFF',
            border: '1px solid #006EC3',
          }}
          loading={isLoading}
          onClick={() => {
            if (isServicesFilterDetailsModalVisible || isModeBasedFilterOptionsLoading) return;
            handleSearch();
          }}
          // disabled={isModeBasedFilterOptionsLoading}
        >
          Search
        </Button>
      </Col>
    );
  };

// Fix the handleSearch function to clear the opposite field when setting a new selection
const handleSearch = (): void => {
  form.validateFields(
    async (err, values): Promise<void> => {
      if (err) return;
      getGAEventCategory(orgType, `Search - ${searchFilters?.view?.toLowerCase()} rates`);
      setState({ isLoading: true });
      await sleep(1000);
      const container = JSON.parse(values.ContainerList || '[]');
      const cargo = JSON.parse(values.CargoList || '[]');
      let incoterm, shipperTeamId, grossWeight, totalVolume, totalVolumetricWeight;
      if (orgType === "SHIPPER") {
        incoterm = JSON.parse(values.incoterm || '{}')
      }
      const { length, breadth, height, dimensionUnit, count = 1, grossWeightUnit } = values;
      if (mode !== FCL) {
        grossWeight = {
          unit: grossWeightUnit,
          value: values.grossWeight
        }
        // if we selected to input l x b x h then calc volume else just assign volume directly
        const { volume, volumeUnit } = calculateVolume(
          { length, breadth, height },
          +values.totalVolume,
          isVolumeInputSelected ? values.volumeUnit : dimensionUnit
        );
        totalVolume = {
          unit: volumeUnit,
          value: volume * count
        }
        totalVolumetricWeight = {
          unit: 'kg',
          value: calculateVolumetricWeight() * count
        }
      }
      if (props.userRole === UserRole.ADMIN) { shipperTeamId = props.shipperTeamId; }

      // Helper function to process location data
      const processLocationData = (selected) => {
        if (!selected) return { city: undefined, state: undefined, countryId: selected?.countryId };
        
        if (selected.id && selected.id.toString().startsWith('city_')) {
          return {
            city: selected.city === searchOrginDestinationType.ALL ? selected.city : selected.code,
            state: undefined, // Clear state when city is selected
            countryId: selected?.countryId
          };
        } else if (selected.id && selected.id.toString().startsWith('state_')) {
          return {
            city: undefined, // Clear city when state is selected
            state: selected.code,
            countryId: selected?.countryId
          };
        } else if (selected.city || selected.state) { 
          return {
            city: selected.city,
            state: selected.state,
            countryId: selected?.countryId
          };
        } else {
          return {
            city: selected.code,
            state: undefined,
            countryId: selected?.countryId
          };
        }
      };

      // Process origin and destination data
      const originData = processLocationData(polSelected);
      const destinationData = processLocationData(podSelected);

      setSearchFilterValues({
        mode: values.mode,
        includeExpiredRates: values.includeExpiredRates,
        container: values.ContainerList,
        cargo: values.CargoList,
        ...(!isGridViewVisible() && {
          pol: polSelected,
          pod: podSelected,
          fromGridView: false,
          polGroupId: polSelected?.filterType === 'portGroup' ? polSelected.id.toString(): undefined,
          podGroupId: podSelected?.filterType === 'portGroup' ? podSelected.id.toString() : undefined
        }),
        ...(incoterm && !isModeTypeRPTL && {
          incoterm: incoterm?.label,
          movementType: incoterm?.key,
        }),
        ...(shipperTeamId && { shipperTeamId }),
        ...(grossWeight && { grossWeight }),
        ...(totalVolume && { totalVolume }),
        ...((length || searchFilters.length) && {
          length,
          breadth,
          height,
          dimensionUnit,
          count,
        }),
        ...(totalVolumetricWeight && { totalVolumetricWeight }),
        ...((isModeTypeRoadDomestic || isModeTypeTrailer || isModeTypeRPTL) ? {
          // Clear both city and state first, then set the appropriate one
          originCity: originData.city,
          originState: originData.state,
          originCountryId: originData.countryId,
          destinationCity: destinationData.city,
          destinationState: destinationData.state,
          destinationCountryId: destinationData.countryId,
          ...((isModeTypeRoadDomestic || isModeTypeTrailer) && { vehicle: values?.vehicle }),
          ...(isModeTypeRPTL && { vehicle: undefined })
        } : {}),
        originGeoRadius: {value: values.originGeoRadiusValue, unit: values.originGeoRadiusUnit},
        destinationGeoRadius: {value: values.destinationGeoRadiusValue, unit: values.destinationGeoRadiusUnit},
      });

      addToLocalStorage({
        mode: values.mode,
        container,
        cargo,
        ...(!isGridViewVisible() && {
          pol: polSelected,
          pod: podSelected,
        }),
        ...(incoterm?.label && !isModeTypeRPTL && {
          incoterm: incoterm?.label,
          movementType: incoterm?.key,
        }),
        ...(isLandingPage && { includeExpiredRates: values.includeExpiredRates }),
        ...(shipperTeamId && { shipperTeamId }),
        ...(grossWeight && { grossWeight }),
        ...(totalVolume && { totalVolume }),
        ...((length || searchFilters.length) && { length, breadth, height, dimensionUnit, count }),
        ...(totalVolumetricWeight && { totalVolumetricWeight }),
        ...((isModeTypeRoadDomestic || isModeTypeTrailer || isModeTypeRPTL) && {
          originCity: originData.city,
          originState: originData.state,
          originCountryId: originData.countryId,
          destinationCity: destinationData.city,
          destinationState: destinationData.state,
          destinationCountryId: destinationData.countryId,
          ...((isModeTypeRoadDomestic || isModeTypeTrailer) && { vehicle: values?.vehicle }),
          ...(isModeTypeRPTL && { vehicle: undefined })
        }),
        // originGeoRadius: { value: originGeoRadius.value, unit: originGeoRadius.unit },
        // destinationGeoRadius: { value: destinationGeoRadius.value, unit: destinationGeoRadius.unit },
      })  
      getAllDataResetFilter(false, false);
      getAllDataSetFilter(
        (serviceDetails && !isEmpty(serviceDetails)) ?
        serviceDetails :
        {
          originServices: directServices.filter((service) => originServices?.includes(service)),
          destinationServices: directServices.filter((service) => destinationServices?.includes(service))
        },
        false
      );
      await sleep(500);
      viewType === GridView.GRID ? fetchGridData(true) : fetchAllData({isSearch: true});
      getAllDataSetSortByFilter({ sortBy: 'totalPrice' }, false);
      !isDiscoverPage && routeToPage();
      setState({ isLoading: false });
      viewType === GridView.GRID && setGridSearchHistory();
    }
  );
};

  const routeToPage = () => {
    if (showDiscoverBuyRates && searchFilters?.view !== 'SELL') {
      history.push(getDiscoverRatesRoute('buy'), { fromPopUp: !isLandingPage });
    } else if (showDiscoverSellRates) {
      setSearchFilterValues({ view: 'SELL' });
      history.push(getDiscoverRatesRoute('sell'), { fromPopUp: !isLandingPage });
    } else return;
  };

  const setSavedArray = (object): void => {
    const duplicateSearch = localStorageSavedValues.findIndex((item) => {
      return equal(item, object);
    });
    // calculated count mode wise so that we store at max 10 values for each mode in localStorage
    const modeWiseSearchLength = localStorageSavedValues.reduce((acc, cur) => acc += cur.mode === mode ? 1 : 0, 0)
    if (duplicateSearch !== -1) {
      localStorageSavedValues.splice(0, 0, localStorageSavedValues.splice(duplicateSearch, 1)[0]);
    } else {
      modeWiseSearchLength >= 10 && localStorageSavedValues.pop();
      localStorageSavedValues.unshift(object);
    }
  };

  const addToLocalStorage = (data): void => {
    setSavedArray(data);
    window.localStorage.setItem(
      `${isGridViewVisible()
        ? savedInLocalStorage.SAVED_GRID_SEARCH
        : savedInLocalStorage.SAVED_SEARCH
      }`,
      JSON.stringify(localStorageSavedValues)
    );
  };

  const getCargoFromContainer = (containerListValue?) => {
    if (mode !== FCL) {
      const cargoToShow = Array.from(
        new Set(
          (modeBasedFilterOptions.cargoList || [])
            ?.map((cargo) => cargo.key?.cargo)
        )
      );
      return cargoToShow;
    }
    const containerSelected = JSON.parse(containerListValue || form.getFieldValue('ContainerList') || '{}');
    let filteredCargoFromContainer;
    (modeBasedFilterOptions.containerList || []).forEach((container) => {
      if (container.key.type === containerSelected?.key?.type) {
        filteredCargoFromContainer = container?.cargoList
      }
    });
    return filteredCargoFromContainer;
  };

  const renderCargoSearch = (title): React.ReactElement => {
    const cargoListOptions = modeBasedFilterOptions.cargoList || [];
    const filteredCargoList = getCargoFromContainer();
    return (
      <Col
        span={getContainerCargoColSpan()}
        className={
          isLandingPage
            ? classNames(classes.landingPageOptions, classes.landingPageCargo)
            : classes.optionsDiv
        }
      >
        {renderSearchTitle(title)}
        <Form.Item className={getFormItemClassName(isLandingPage, classes)}>
          {form.getFieldDecorator('CargoList', {
            rules: [{ required: true, message: 'Cargo is required' }],
            // initialValue: searchFilters?.cargo,
            initialValue: undefined,
          })(
            <Select
              mode="default"
              className={classes.select}
              dropdownClassName={classes.dropdown}
              showArrow={false}
              dropdownMatchSelectWidth={false}
              filterOption={(inputValue, option: any) => {
                if (!inputValue) {
                  return true;
                }

                // To get the label in search since styling is given to it
                const optionval =
                  `${option?.props?.children[0].toLowerCase()} ${option?.props?.children[2]?.props?.children?.toLowerCase()}` ||
                  '';
                return optionval.includes(inputValue.trim().toLowerCase());
              }}
              showSearch
              placeholder={title}
              disabled={isModeBasedFilterOptionsLoading}
            >
              {cargoListOptions?.map((list) => {
                if (list.showAlways && filteredCargoList?.includes(list?.key?.cargo)) {
                  return <Select.Option
                    key={JSON.stringify({
                      key: list.key,
                      label: list.label,
                    })}
                  >
                    <span>{list.label.cargo}&nbsp;</span>
                    <span style={{ fontSize: '10px', fontWeight: 'normal' }}>
                      {list.label.product}
                    </span>
                  </Select.Option>;
                } return null
              })}
            </Select>
          )}
        </Form.Item>
      </Col>
    );
  };

  const renderWeight = () => {
    return <Col
      span={isLandingPage ? 3 : 7}
      style={{ top: isLandingPage ? '-4px' : '-12px', right: isLandingPage ? '0' : '-8px' }}
      className={classes.unitDropdown}>
      <Form.Item
        className={getFormItemClassName(isLandingPage, classes)}
      >
        {form.getFieldDecorator(`grossWeightUnit`, {
          rules: [{ required: true, message: `Required` }],
          initialValue: searchFilters?.grossWeight?.unit || 'kg',
        })(
          <Select
            className={classNames(classes.titleDropdown)}
            dropdownClassName={classes.titleDropdownMenu}
          >
            {discoverRatesMaps?.weightsUnits.map((item) => {
              return (
                <Select.Option key={item}>{item}</Select.Option>
              );
            })}
          </Select>
        )}
      </Form.Item>
    </Col>
  }

  const renderGrossWeight = (title: string, fieldKey: string, initialValue, isOptional = false): React.ReactElement => {
    return (
      <Col
        span={getContainerCargoColSpan()}
        className={
          isLandingPage
            ? classNames(classes.landingPageOptions, classes.landingPageCargo)
            : classes.optionsDiv
        }
      >
        <Row
          className={
            isLandingPage
              ? classNames(classes.selectTitleWidth, classes.selectTitle)
              : classes.selectTitle
          }
        >
          <Col>{title}</Col>
          {!isLandingPage && renderWeight()}
        </Row>
        {renderInputNumber({
            key: fieldKey,
            form,
            formItemClasses: getFormItemClassName(isLandingPage, classes),
            rules: [{ required: !isOptional, message: 'Required' }],
            placeholder: title,
            min: 0.01,
            precision: 2,
            initialValue,
            inputClasses: classes.input,
            disabled:isModeBasedFilterOptionsLoading
          })}
        {isLandingPage && renderWeight()}
      </Col>
    );
  };

  const calculateVolume = (dimensions: Dimensions, volume: number, unit: string) => {
    if (volume) return { volume, volumeUnit: unit };
    const { volumeConversionMap } = discoverRatesMaps;
    const { length, breadth, height } = dimensions;
    const conversionUnit: number = volumeConversionMap?.cbm?.[`cu ${unit}`] || 1;
    return { volume: (length * breadth * height) / conversionUnit, volumeUnit: 'cbm' };
  }

  const renderVolumeUnit = () => {
    const { lengthUnits, volumeUnits } = discoverRatesMaps;
    const unit = searchFilters?.totalVolume?.unit??'cbm'
    return <Col span={isLandingPage ? 3 : 5}
      style={{ top: isLandingPage ? '-4px' : '-12px', right: !isLandingPage ? '-8px' : '0' }}
      className={classes.unitDropdown}>
      <Form.Item
        className={getFormItemClassName(isLandingPage, classes)}
      >
        {form.getFieldDecorator(isVolumeInputSelected ? 'volumeUnit' : 'dimensionUnit', {
          rules: [{ required: true, message: `Required` }],
          initialValue: isVolumeInputSelected ? unit : 'cm',
        })(
          <Select
            className={classNames(classes.titleDropdown)}
            dropdownClassName={classes.titleDropdownMenu}
            dropdownMatchSelectWidth
            dropdownStyle={{margin: 6}}
          >
            {(isVolumeInputSelected ? volumeUnits : lengthUnits).map((item) => {
              return (
                <Select.Option key={item}>{item}</Select.Option>
              );
            })}
          </Select>
        )}
      </Form.Item>
    </Col>
  }

  const calculateVolumetricWeight = () => {
    const { volumetricWeightDenominator, volumeConversionMap } = discoverRatesMaps;
    let volWt = 0;
    if (state.isVolumeInputSelected){
      const volumeUnit = form.getFieldValue('volumeUnit');
      let totalVolume = form.getFieldValue('totalVolume') || 0;
      if (volumeUnit !== 'cbm'){
        totalVolume *= volumeConversionMap?.[volumeUnit]?.cbm??1;
      }
      volWt = +(((totalVolume * 1000000) / volumetricWeightDenominator) || 0).toFixed(2);
    } else {
      volWt = +(((+calculateTotalVolume() * 1000000) || 0 ) / volumetricWeightDenominator);
    }
    return volWt;
  }

  const renderVolumetricWeight = () => {
    const count = form.getFieldValue('count') || 1;
    return <div style={{ padding: 12, top: isLandingPage ? '20px' : '-12px', right: isLandingPage ? '0px' : '40px' }}
      className={classes.unitDropdown}>
        <span style={{color: '#999', fontSize: 10, fontStyle: 'italic'}}>Vol. Wt.: {(calculateVolumetricWeight() * count).toFixed(2)}kg</span>
    </div>
  }

  const renderVolume = (title: string, fieldKey: string, isOptional = false): React.ReactElement => {
    return (
      <Col
        span={7}
        className={
          isLandingPage
            ? classNames(classes.landingPageOptions, classes.landingPageCargo)
            : classes.optionsDiv
        }
      >
        <Row
          className={
            isLandingPage
              ? classNames(classes.selectTitleWidth, classes.selectTitle)
              : classes.selectTitle
          }
        >
          <Col span={24} style={{ minWidth: '60px' }}>
            {isVolumeInputSelected ? 'Total Volume' : 'L x B x H'}
            <Tooltip overlayStyle={{ width: '140px', fontSize: '11px' }} title="Switch to L, B, H mode of measurements">
              <Icon onClick={() => setState({ isVolumeInputSelected: !isVolumeInputSelected })} type="retweet" style={{ fontSize: '12px', marginLeft: '4px', cursor: 'pointer' }} />
            </Tooltip>
          </Col>
          {(mode === AIRCARGO && !isLandingPage) && renderVolumetricWeight()}
          {!isLandingPage && renderVolumeUnit()}
        </Row>
        {isVolumeInputSelected ? renderInputNumber({
          key: fieldKey,
          form,
          formItemClasses: getFormItemClassName(isLandingPage, classes),
          rules: [{ required: !isOptional, message: 'Required' }],
          placeholder: title,
          min: 0.01,
          precision: 2,
          initialValue: searchFilters?.totalVolume?.value,
          inputClasses: classes.input
        }): <Row style={isLandingPage&&{width: '80%', marginRight: 60 }||{}} >
          <Col span={4}> 
          {renderInputNumber({
            key: 'length',
            form,
            formItemClasses: classNames(getFormItemClassName(isLandingPage, classes), classes.lbhSelected),
            rules: [{ required: !isOptional, message: 'Required' }],
            placeholder: 'length',
            min: 0.01,
            precision: 2,
            initialValue: searchFilters?.length,
            inputClasses: classNames(classes.input, classes.lbhSelected)
          })}
          </Col>
          <Col span={1} className={classes.multiplySymbol}>x</Col>
          <Col span={4}> {renderInputNumber({
            key: 'breadth',
            form,
            formItemClasses: classNames(getFormItemClassName(isLandingPage, classes), classes.lbhSelected),
            rules: [{ required: !isOptional, message: 'Required' }],
            placeholder: 'breadth',
            min: 0.01,
            precision: 2,
            initialValue: searchFilters?.breadth,
            inputClasses: classNames(classes.input, classes.lbhSelected)
          })}
          </Col>
          <Col span={1} className={classes.multiplySymbol}>x</Col>
          <Col span={4}> {renderInputNumber({
            key: 'height',
            form,
            formItemClasses: classNames(getFormItemClassName(isLandingPage, classes), classes.lbhSelected),
            rules: [{ required: !isOptional, message: 'Required' }],
            placeholder: 'height',
            min: 0.01,
            precision: 2,
            initialValue: searchFilters?.height,
            inputClasses: classNames(classes.input, classes.lbhSelected)
          })}
          </Col>
          <Col span={1} style={{ borderRight: '1px solid #eee', height: '20px', marginTop: '10px' }} />
          <Col offset={1} span={8}> 
          {renderInputNumber({
            key: 'count',
            form,
            formItemClasses: classNames(getFormItemClassName(isLandingPage, classes), classes.lbhSelected),
            rules: [{ required: true, message: 'Required' }],
            placeholder: 'Enter Count',
            min: 1,
            precision: 0,
            initialValue: searchFilters?.count,
            inputClasses: classNames(classes.input, classes.lbhSelected),
          })}
          </Col>
        </Row>}
        {mode === AIRCARGO && isLandingPage && renderVolumetricWeight()}
        {isLandingPage && renderVolumeUnit()}
      </Col>
    );
  };

  const renderIncotermSearch = (title): React.ReactElement => {
    const filteredIncotermList: { key: string, label: string }[] = [];
    Object.keys(modeBasedFilterOptions.incotermList || {}).forEach(key => {
      modeBasedFilterOptions.incotermList[key].forEach(label => {
        filteredIncotermList.push({ key, label });
      });
    });
    const { incoterm, movementType } = searchFilters;
    return (
      <Col
        span={3}
        className={
          isLandingPage
            ? classNames(classes.landingPageOptions, classes.landingPageCargo)
            : classes.optionsDiv
        }
      >
        {renderSearchTitle(title, true)}
        <Form.Item
          className={getFormItemClassName(isLandingPage, classes)}
        >
          {form.getFieldDecorator('incoterm', {
            initialValue: (incoterm && movementType) ? JSON.stringify({ key: movementType, label: incoterm }) : undefined,
          })(
            <Select
              mode="default"
              className={classes.select}
              dropdownClassName={classes.dropdown}
              showArrow={false}
              dropdownMatchSelectWidth={false}
              allowClear
              filterOption={(inputValue, option: any) => {
                if (!inputValue) {
                  return true;
                }
                // To get the label in search since styling is given to it
                const optionval =
                  `${option?.props?.children[0].toLowerCase()} ${option?.props?.children[2]?.props?.children?.toLowerCase()}` ||
                  '';
                return optionval.includes(inputValue.trim().toLowerCase());
              }}
              showSearch
              placeholder={title}
              onChange={(val) => handleIncotermChange(val)}
              disabled={isModeBasedFilterOptionsLoading}
            >
              {filteredIncotermList.map(({ key, label }) =>
              (<Select.Option key={JSON.stringify({ key, label })}>
                {label}{' '}
                <span style={{ fontSize: '10px', fontWeight: 'normal' }}>
                  {key}
                </span>
              </Select.Option>)
              )}
            </Select>
          )}
        </Form.Item>
      </Col>
    );
  };

  const handleIncotermChange = async (value) : Promise<void> => {
    const { key: movementType, label: incoterm } = JSON.parse(value || '{}');
    const services = discoverRatesMaps?.incotermToServices?.[movementType]?.[incoterm]?.[mode];
    const originServices = services?.ORIGIN || [];
    const destinationServices = services?.DESTINATION || [];
    const originStuffingServices = originServices?.filter(service => modeWiseStuffingDestuffingServices[mode]?.includes(service)) as string[];
    const destinationDestuffingServices = destinationServices.filter(service => modeWiseStuffingDestuffingServices[mode]?.includes(service)) as string[];
    if (originStuffingServices?.length || destinationDestuffingServices?.length) {
      setState({
        isServicesFilterDetailsModalVisible: true,
        originServices,
        destinationServices,
        originStuffingServices,
        destinationDestuffingServices,
      });
    } else {
      setState({
        originServices,
        destinationServices,
        originStuffingServices,
        destinationDestuffingServices,
        serviceDetails: {},
      });
    }
  }

  const renderRecentSearchCard = (item): React.ReactElement => {
    const { pol, pod, cargo, incoterm, movementType, container, grossWeight, totalVolume, vehicle } = item;
    const isPolPortGroup = pol?.filterType === 'portGroup'
    const isPodPortProup = pol?.filterType === 'portGroup'
    return (
      <React.Fragment>
        {!isGridViewVisible() && (
          <React.Fragment>
            {isPolPortGroup ? (
                <span>
                  <strong>{pol?.group_name}</strong> - &nbsp;
                </span>
            ) : (
              <span>
                <strong>{pol?.code}</strong> {mode !== AIRCARGO && `(${pol?.name})`} - &nbsp;
              </span>
            )}
            {isPodPortProup ? (
              <span>
                <strong>{pod?.group_name}</strong> &nbsp;|&nbsp;
              </span>
            ): (
              <span>
                  <strong>{pod?.code}</strong> {mode !== AIRCARGO && `(${pod?.name})`} &nbsp;|&nbsp;
              </span>
            )}
           
          </React.Fragment>
        )}
        {container?.label?.type && <React.Fragment>
          <strong>{container?.label?.type}</strong>-{container?.label?.size}&nbsp;|&nbsp;
          </React.Fragment>
        }
        <strong>{cargo?.label?.cargo}</strong>-{cargo?.label?.product}
        {
          orgType === 'SHIPPER' && <React.Fragment>
            {incoterm && movementType && !(isModeTypeRoadDomestic || isModeTypeTrailer || isModeTypeRPTL) && (<React.Fragment>&nbsp;|&nbsp;<strong>{incoterm}</strong>-{movementType}</React.Fragment>)}
            {grossWeight && !(isModeTypeRoadDomestic || isModeTypeTrailer || isModeTypeRPTL) && (<React.Fragment>&nbsp;|&nbsp;Gross Weight: <strong>{`${grossWeight?.value} ${grossWeight?.unit}`}</strong>&nbsp;|&nbsp;</React.Fragment>)}
            {totalVolume && !(isModeTypeRoadDomestic || isModeTypeTrailer || isModeTypeRPTL) && (<React.Fragment>Total Volume: <strong>{`${totalVolume?.value} ${totalVolume?.unit}`}</strong></React.Fragment>)}
          </React.Fragment>
        }
        {vehicle && <React.Fragment>
          <strong>&nbsp;|&nbsp;Vehicle</strong>-<span>{vehicle}</span>
          </React.Fragment>
        }
      </React.Fragment>
    );
  };

  const getPortIds = (portList) => {
    return portList?.map((port) => port.dbId);
  };

  const setGridSearchHistory = (item?) => {
    const containerList = form.getFieldValue('ContainerList');
    const cargoList = form.getFieldValue('CargoList');
    const container = item ? item.container : JSON.parse(containerList || '[]');
    const cargo = item ? item.cargo : JSON.parse(cargoList || '[]');
    saveGridSearchHistory({
      polIds: getPortIds(gridPorts?.POLList),
      podIds: getPortIds(gridPorts?.PODList),
      container: container?.key,
      cargo: cargo?.key,
      mode: FCL,
      view: searchFilters.view,
    });
  };

  const handleRecentSearchClick = (item): void => {
    setState({ isLoading: true });
    const ContainerList = JSON.stringify(item.container);
    const CargoList = JSON.stringify(item.cargo);
    const { mode, movementType, incoterm, grossWeight, totalVolume, vehicle } = item;
    setSearchFilterValues({
      mode,
      ...(!isGridViewVisible() && {
        pol: item.pol,
        pod: item.pod,
      }),
      container: ContainerList,
      cargo: CargoList,
      ...(incoterm && movementType && {
        incoterm, movementType
      }),
      ...(grossWeight && { grossWeight }),
      ...(totalVolume && { totalVolume }),
      ...(vehicle && { vehicle })
    });
    if (!isGridViewVisible()) {
      setState({
        polSelected: item.pol,
        podSelected: item.pod,
      });
    }
    if (isDiscoverPage) {
      form.setFieldsValue({
        mode,
        ContainerList,
        CargoList,
        polId: { key: item.pol?.id, label: renderPortOption(item.pol) },
        podId: { key: item.pod?.id, label: renderPortOption(item.pod) },
        incoterm: (item.incoterm && item.movementType) ? JSON.stringify({ key: item.movementType, label: item.incoterm }) : undefined,
        grossWeight: grossWeight?.value,
        grossWeightUnit: grossWeight?.unit,
        totalVolume: totalVolume?.value,
        volumeUnit: totalVolume?.unit,
        vehicle,
      });
    }
    addToLocalStorage({
      mode,
      container: item.container,
      cargo: item.cargo,
      ...(!isGridViewVisible() && {
        pol: item.pol,
        pod: item.pod,
        ...(incoterm && movementType && {
          incoterm, movementType
        }),
      }),
      ...(grossWeight && { grossWeight }),
      ...(totalVolume && { totalVolume }),
      ...(vehicle && { vehicle })
    });

    viewType === GridView.GRID ? fetchGridData(true) : fetchAllData({isSearch: true});
    getAllDataResetFilter(false);
    getAllDataSetSortByFilter({ sortBy: 'totalPrice' }, false);
    !isDiscoverPage && routeToPage();
    getGAEventCategory(orgType, `Search - ${searchFilters?.view?.toLowerCase()} rates`);
    setState({ isLoading: false });
    viewType === GridView.GRID && setGridSearchHistory(item);
  };

  const renderRecentSearchesDropdown = (modeWiseFilteredSearches): React.ReactElement => {
    return (
      <Dropdown
        trigger={['click']}
        placement="bottomCenter"
        overlayClassName={classes.dropDownStyle}
        overlay={
          <Menu>
            {modeWiseFilteredSearches?.map(
              (item, index) => {
                return index >= 2 && (
                  <Menu.Item key={index}>
                    <span
                      style={{
                        fontSize: '14px',
                        cursor: 'pointer'
                      }}
                      onClick={() => handleRecentSearchClick(item)}
                    >
                      {renderRecentSearchCard(item)}
                    </span>
                  </Menu.Item>
                )
              }
            )}
          </Menu>
        }
      >
        <Icon type="double-right" />
      </Dropdown>
    );
  };

  const renderRecentSearches = (): React.ReactElement | undefined => {
    const modeWiseFilteredSearches = localStorageSavedValues?.filter(item => item.mode === mode);
    if (modeWiseFilteredSearches.length <= 1) return;
    return (
      <div style={{ fontSize: '12px' }}>
        <span style={{ marginRight: '10px' }}>Your Recent Searches :</span>
        <span
          className={classes.recentSearchCard}
          onClick={() => handleRecentSearchClick(modeWiseFilteredSearches[1])}
        >
          {modeWiseFilteredSearches[1] && renderRecentSearchCard(modeWiseFilteredSearches[1])}
        </span>
        {modeWiseFilteredSearches?.length > 2 && renderRecentSearchesDropdown(modeWiseFilteredSearches)}
      </div>
    );
  };

  const getViewStyle = (flag) => {
    return {
      marginLeft: isDiscoverPage ? '1px' : '4px',
      backgroundColor: flag ? '#F0E4C4' : '#E3D3A9',
      color: flag ? '#333333' : '#A29B87',
      borderColor: flag ? '#333333' : '#A29B87',
    };
  };

  const handleGridViewClick = () => {
    if (searchFilters.viewType === GridView.GRID) return;
    if (searchFilters?.view === 'SELL') {
      history.push(getDiscoverRatesRoute('buy'));
    }
    setSearchFilterValues({ viewType: GridView.GRID, view: 'BUY', fromGridView: false });
    getAllDataSetSortByFilter(
      {
        sortBy: 'totalPrice',
        sortByOrder: 'ASC',
      },
      false
    );
    setGridFiltersRange({
      freightPrice: gridFreightRange,
      transitDays: gridTransitRange,
    });
  };

  const renderViewMode = (): React.ReactElement => {
    return (
      <div
        style={{
          margin: isDiscoverPage ? '0px 11%' : '0px 3%',
        }}
      >
        <span
          style={{ ...getViewStyle(!isGridViewVisible()) }}
          className={classes.viewDiv}
          onClick={() => {
            searchFilters.viewType !== GridView.LIST &&
              setSearchFilterValues({ viewType: GridView.LIST, view: 'BUY', fromGridView: false });
            sendEvent(EventCategories.DISCOVER_RATES_SEARCH_FF, 'List view clicked');
          }}
        >
          <Icon type="menu" /> List View
        </span>
        <span
          style={{ ...getViewStyle(isGridViewVisible()) }}
          className={classes.viewDiv}
          onClick={() => {
            handleGridViewClick();
            sendEvent(EventCategories.DISCOVER_RATES_SEARCH_FF, 'Grid view clicked');
          }}
        >
          <Icon type="appstore" theme="filled" /> Grid View
        </span>
      </div>
    );
  };

  const { length, breadth, height } = form.getFieldsValue(['length', 'breadth', 'height'])
  const calculateTotalVolume = () => {
    const dimensionUnit = form.getFieldValue('dimensionUnit');
    const { volume } = calculateVolume({length, breadth, height}, 0, dimensionUnit);
    return removeTrailingZero(volume.toFixed(6));
  }

  const renderChargesApplicableCard = () => {
    const showTotalVolume = (length && breadth && height && mode === LCL);
    const showVolumetricWeight = (mode === AIRCARGO && form.getFieldValue('grossWeight'));
    const count = form.getFieldValue('count') || 1;
    let volWt, weight, chargesApplicableOnLabel;
    if (showVolumetricWeight){
      const { weightConversionMap } = discoverRatesMaps;
      const { grossWeight, grossWeightUnit } = form.getFieldsValue(['grossWeight', 'grossWeightUnit']);
      const conversionFactor = weightConversionMap?.[grossWeightUnit]?.kg;
      volWt = (calculateVolumetricWeight() * count).toFixed(2);
      weight = conversionFactor * grossWeight;
      chargesApplicableOnLabel = volWt > weight ? 'Vol.' : 'Gross'
    }
    if (showTotalVolume || showVolumetricWeight) {
      return (
        <div style={{ pointerEvents: 'none' }}>
          <Button
            className={classes.chargesApplicableCardBtn}
            style={isLandingPage ? {width: '100%', textAlign: 'left'} : {}}
            type="dashed"
            size="small"
          >
            { showTotalVolume && <span style={{ fontWeight: 600 }}>Total Volume:&nbsp;{calculateTotalVolume() * count} cbm</span>}
            { showVolumetricWeight && <>
              Charges applicable on
              <span style={{ fontWeight: 600 }}>
                &nbsp;Total {chargesApplicableOnLabel} Wt.:&nbsp;{Math.max(volWt, weight)}&nbsp;kg
              </span>
            </>}
          </Button>
        </div>
      );
    }
    return null;
  };

  const getServiceType = (services) => {
    if (!services) return;
    if (services.includes('Transportation Service')) {
      return 'Transportation Service';
    }
    if (services.includes('Freight Service')) {
      return 'Freight Service';
    }
    return 'Custom Clearance Service';
  }

  const renderServicesFilterDetailsModal = () : React.ReactElement => {
    return (
      <DiscoverRatesServicesFilterDetailsModal
        isVisible={isServicesFilterDetailsModalVisible}
        handleClose={(serviceDetails) => {
          setState({ isServicesFilterDetailsModalVisible: false, serviceDetails });
        }}
        isFetchingAddresses={isFetchingAddresses}
        stuffingAddresses={stuffingAddresses}
        deStuffingAddresses={deStuffingAddresses}
        services={{
          ...(originStuffingServices?.length && {
            origin: {
              key: "originServices",
              serviceType: getServiceType(originStuffingServices),
              type: originServices,
            }
          }),
          ...(destinationDestuffingServices?.length && {
            destination: {
              key: "destinationServices",
              serviceType: getServiceType(destinationDestuffingServices),
              type: destinationServices,
            }
          }),
        }}
        mode={mode}
      />
    );
  };

  const renderVehicleTypeFilter = (title = 'Vehicle') => {
    const options = modeBasedFilterOptions?.vehicleTypeList || []
    return (
      <Col
        span={getContainerCargoColSpan()}
        className={
          isLandingPage
            ? classNames(classes.landingPageOptions, classes.landingPageCargo)
            : classes.optionsDiv
        }
      >
        {renderSearchTitle(title)}
        <Form.Item className={getFormItemClassName(isLandingPage, classes)}>
          {form.getFieldDecorator('vehicle', {
            rules: [{ required: true, message: 'Vehicle is required' }],
            initialValue: searchFilters?.vehicle,
          })(
            <Select
              disabled={isModeBasedFilterOptionsLoading}
              mode="default"
              className={classes.select}
              dropdownClassName={classes.dropdown}
              showArrow={false}
              dropdownMatchSelectWidth={false}
              filterOption={(inputValue, option: any) => {
                if (!inputValue) {
                  return true;
                }

                // To get the label in search since styling is given to it
                const optionval =
                  `${option?.props?.children[0].toLowerCase()} ${option?.props?.children[2]?.props?.children?.toLowerCase()}` ||
                  '';
                return optionval.includes(inputValue.trim().toLowerCase());
              }}
              showSearch
              placeholder={title}
            >
              {options?.map((item) => (
                <Select.Option key={item.key}>{item.label}</Select.Option>
              ))}
            </Select>
          )}
        </Form.Item>
      </Col>
    );
  }

  const RecentSearchModeWiseLength = React.useMemo(() => localStorageSavedValues?.filter(item => item.mode === mode).length > 1, [localStorageSavedValues])

  const getOriginDestinationLabel = (isDestination = false) => {
    if (isModeTypeRoadDomestic || isModeTypeRPTL || (isModeTypeTrailer && !isDestination)) {
      return 'City/State';
    } else if (mode === AIRCARGO) {
      return '';
    } else if (isModeTypeTrailer && isDestination) {
      return 'City/Port/State';
    } else {
      return 'Port';
    }
  }

  const renderIncludeExpiredRates = (savedValue: boolean = false) => {
    return (
      <div 
        className={classNames({ [classes.absoluteOptionsDiv]: !isLandingPage })} 
        style={{ marginLeft: isLandingPage ? '0' : '80%' }}>
        {form.getFieldDecorator('includeExpiredRates', {
        })
        (<Checkbox
          checked={searchFilters?.includeExpiredRates }
          onChange={(e) => setSearchFilterValues({ includeExpiredRates: e.target.checked })}
          disabled={isModeBasedFilterOptionsLoading}
        >Include Expired Rates</Checkbox>)}
      </div>
    );
  }

  const renderGroupPortsCities = (target: 'origin' | 'destination',disable:boolean) => {
    const labelSuffix = mode === DOMESTIC ? 'Cities' : 'Ports';
    const enablePopupBox = state[`${target}GroupRadiusPopupBoxVisible`];
    const editRadius = state?.[`s_${target}GeoRadius`]?.value;
    return <div className={classes.absoluteOptionsDiv}>
      {form.getFieldDecorator(`${target}GeoRadiusCheck`, {
        initialValue: false
      })(<Checkbox
        checked={form.getFieldValue(`${target}GeoRadiusCheck`)}
        onChange={(e) =>  checkUncheckGroupRadiusFilter(target, e)}
        disabled={disable}
      />)}
      <div style={{ color: disable ? '#A9A9A9' : '#000000' }}>Group {labelSuffix}</div>
      <div
  style={{
    position: 'relative',
    opacity: disable ? 0.5 : 1, // Grey out the entire component when disabled
    pointerEvents: disable ? 'none' : 'auto', // Prevent interactions if disabled
  }}
>
  <div className={classes.groudRadiusToggleBtn}>
    <Popover
      content={renderGroupRaduisPopupBox(target)}
      visible={enablePopupBox && !disable} // Prevent popover if disabled
      trigger={'click'}
      placement='bottomLeft'
      onVisibleChange={() => !disable && toggleGroupRadiusPopupBox(target)}
      destroyTooltipOnHide
    >
      <span
        onClick={() => !disable && toggleGroupRadiusPopupBox(target)} // Disable click if `disable` is true
        style={{
          color: disable ? '#A9A9A9' : '#000000', // Grey out the text if disabled
        }}
      >
        {editRadius ? 'Edit' : ''} Radius
      </span>
    </Popover>
  </div>
</div>
    </div>
  };

  const renderGroupRaduisPopupBox = (target: 'origin' | 'destination') => {
    return (
      <div className={classes.groupRadiusBoxContainer}>
        <Row style={{fontSize: '12px'}}>
          <Col span={16}>Grouping Radius</Col>
          <Col span={8} style={{display: 'flex', columnGap: '5px', justifyContent: 'end'}}>
            <div style={{color: tokens.colors.primaryDark, fontWeight: 600}}>{form.getFieldValue(`${target}GeoRadiusValue`) || state?.[`s_${target}GeoRadius`]?.value}</div>
            <div>{groupRadiusUnitMap[form.getFieldValue(`${target}GeoRadiusUnit`) || state?.[`s_${target}GeoRadius`]?.unit]}</div>
            <div>
              {form.getFieldDecorator(`${target}GeoRadiusUnit`, {
                initialValue: state?.[`s_${target}GeoRadius`]?.unit || defaultDistanceUnit || 'km',
              })(
                <Dropdown
                  trigger={['click']}
                  overlayClassName={classes.dropDownStyle}
                  overlay={
                    <Menu onClick={(param) => handleGeoRadiusUnitChange(`${target}GeoRadiusUnit`, param?.key)}>
                      <Menu.Item key="mi">Mi</Menu.Item>
                      <Menu.Item key="km">Km</Menu.Item>
                    </Menu>
                  }
                >
                  <Icon type="down" />
                </Dropdown>
              )}
            </div>
          </Col>
        </Row>
        <div>
          {form.getFieldDecorator(`${target}GeoRadiusValue`, {
            initialValue: state?.[`s_${target}GeoRadius`]?.value || 0,
          })(<Slider marks={{ 50: '50', 500: '500' }} min={50} max={500} className={classes.customSlider}/>)}
        </div>
        <div style={{borderTop: `solid 1px ${tokens.colors.border}`, paddingTop: '10px'}}>
          <Button 
            type="primary" 
            onClick={() => applyGroupRadiusFilter(target)} 
            disabled={!form.getFieldValue(`${target}GeoRadiusValue`)}
          >
              Update
          </Button>
        </div>
      </div>
    );
  };

  const toggleGroupRadiusPopupBox = (target: 'origin' | 'destination') => {
    const targetToHide = target === 'origin' ? 'destination' : 'origin';
    return setState({ 
      [`${target}GroupRadiusPopupBoxVisible`]: !state[`${target}GroupRadiusPopupBoxVisible`],
      [`${targetToHide}GroupRadiusPopupBoxVisible`]: false
    });
  }

  const applyGroupRadiusFilter = (target: 'origin' | 'destination') => {
    const value = {
      value: form.getFieldValue(`${target}GeoRadiusValue`),
      unit: form.getFieldValue(`${target}GeoRadiusUnit`) as 'mi' | 'km',
    };
    form.setFieldsValue({
      [`${target}GeoRadiusCheck`]: !!form.getFieldValue(`${target}GeoRadiusValue`),
    });
    setState({ [`s_${target}GeoRadius`]: value });
  };

  const checkUncheckGroupRadiusFilter = (target: 'origin' | 'destination', e) => {
    setState({
      [`s_${target}GeoRadius`]: e?.target?.checked ? { value: 100, unit: defaultDistanceUnit || 'km' } : { value: 0, unit: defaultDistanceUnit || 'km' },
    });
    form.setFieldsValue({
      [`${target}GeoRadiusValue`]: e?.target?.checked ? 100 : 0,
      [`${target}GeoRadiusUnit`]: defaultDistanceUnit || 'km',
    });
  };

  const handleGeoRadiusUnitChange = (formKey, value) => {
    form.setFieldsValue({ [formKey]: value });
  }

  const filterPortsAndGroups = (portsAndGroupsList, modeValue) => {
    return portsAndGroupsList?.filter(item => {
      if (!item?.filterType || item?.filterType !== 'portGroup') {
        return true;
      }

      switch (modeValue) {
        case 'FCL': 
        case 'LCL':
         // show only ports and port groups of type WET PORT and DRY PORT 
          return item?.type === 'WET PORT' || item?.type === 'DRY PORT';
        case 'AIRCARGO':
          return item?.type === 'AIRPORT'
        case 'DOMESTIC':
            return item?.type === 'CITY'
        case 'TRAILER':
          return true
        default:
          return true
      }

    });
  }

  const handleModeBasedSearchFilterOptions = async () => {
    setState({
      isModeBasedFilterOptionsLoading: true,
    });
    setIntial();
    form.resetFields(['ContainerList', 'CargoList', 'polId', 'podId', 'vehicle']);
    await sleep(1000)
    const response = await fetchModeBasedSearchFilters({
      mode,
      chargeCategory: 'FREIGHT',
    })
    if (response.isSuccess) {
      const data = response.data;
      const modeFieldValue = form.getFieldValue('mode')
      if (data?.cargoList?.length) {
        const newCargoList = data?.cargoList?.filter(item => item?.showAlways);
        data.cargoList = newCargoList;
      }
      if (data?.originList?.length){
        const filteredOriginList = filterPortsAndGroups(data?.originList, modeFieldValue)
        data.originList = filteredOriginList
      }

      if (data?.destinationList?.length) {
        const filteredDestinationList = filterPortsAndGroups(data?.destinationList, modeFieldValue)
        data.destinationList = filteredDestinationList
      }
      if (data?.destinationList?.length && form.getFieldValue('mode') === 'DOMESTIC') {
        data.destinationCityList = data?.destinationList
          ?.filter(item => item?.city)
          .map(item => ({ ...item, id: `city_${item.id}` }));
        data.destinationStateList = data?.destinationList
          ?.filter(item => item?.state)
          .map(({ city, ...rest }) => ({ ...rest, id: `state_${rest.id}` }));
      }

      if (data?.originList?.length && form.getFieldValue('mode') === 'DOMESTIC') {
        data.originCityList = data?.originList
          ?.filter(item => item?.city)
          .map(item => ({ ...item, id: `city_${item.id}` }));
        data.originStateList = data?.originList
          ?.filter(item => item?.state)
          .map(({ city, ...rest }) => ({ ...rest, id: `state_${rest.id}` }));
      }

      if (data?.destinationList?.length && form.getFieldValue('mode') === 'RPTL') {
        data.destinationCityList = data?.destinationList
          ?.filter(item => item?.city)
          .map(item => ({ ...item, id: `city_${item.id}` }));
        data.destinationStateList = data?.destinationList
          ?.filter(item => item?.state)
          .map(({ city, ...rest }) => ({ ...rest, id: `state_${rest.id}` }));
      }

      if (data?.originList?.length && form.getFieldValue('mode') === 'RPTL') {
        data.originCityList = data?.originList
          ?.filter(item => item?.city)
          .map(item => ({ ...item, id: `city_${item.id}` }));
        data.originStateList = data?.originList
          ?.filter(item => item?.state)
          .map(({ city, ...rest }) => ({ ...rest, id: `state_${rest.id}` }));
      }

      if (data?.destinationList?.length && form.getFieldValue('mode') === 'TRAILER') {
        data.destinationCityList = data?.destinationList
          ?.filter(item => item?.city)
          .map(item => ({ ...item, id: `city_${item.id}` }));
        data.destinationStateList = data?.destinationList
          ?.filter(item => item?.state )
          .map(({ city, ...rest }) => ({ ...rest, id: `state_${rest.id}` }));
        data.destinationList = data?.destinationList?.filter(item => item?.type);
      }

      if (data?.originList?.length && form.getFieldValue('mode') === 'TRAILER') {
        data.originCityList = data?.originList
          ?.filter(item => item?.city )
          .map(item => ({ ...item, id: `city_${item.id}` }));
        data.originStateList = data?.originList
          ?.filter(item => item?.state )
          .map(({ city, ...rest }) => ({ ...rest, id: `state_${rest.id}` }));
        data.originList = data?.originList?.filter(item => item?.type);
      }

      orgType === 'SHIPPER' && loadAddresses(data);
      setSearchFilterValues({includeExpiredRates: false});
      await sleep(500);
      handleSearchBarMount(data);
      setState({
        modeBasedFilterOptions: data,
      });
    }
    setState({
      isModeBasedFilterOptionsLoading: false,
      isInitial: false
    });
  }

  const renderSearchBarFields = () => {
    return <>
      {!isGridViewVisible() && (
          <React.Fragment>
            {renderPortsSearch({label: `Origin ${getOriginDestinationLabel(isModeTypeTrailer)}`, title: 'pol', isOrigin: true})}
            {renderPortsSearch({label: `Destination ${getOriginDestinationLabel(isModeTypeTrailer)}`, title: 'pod'})}
            {!isLandingPage && renderIncludeExpiredRates(searchFilters?.includeExpiredRates)}
          </React.Fragment>
        )}
        {[DOMESTIC, TRAILER].includes(mode) && renderVehicleTypeFilter()}
        {[FCL].includes(mode) && renderContainerSearch('Container')}
        {isSharingModule && renderContainerCount()}
        {renderCargoSearch('Cargo')}
        {orgType === 'SHIPPER' && ![DOMESTIC, TRAILER, RPTL].includes(mode) && renderIncotermSearch('Incoterm')}
        {![FCL, DOMESTIC, TRAILER].includes(mode) && renderGrossWeight('Gross Weight', 'grossWeight', searchFilters?.grossWeight?.value, mode === RPTL)}
        {![FCL, DOMESTIC, TRAILER].includes(mode) && renderVolume('Volume', 'totalVolume', mode === RPTL)}
    </>
  }

  return (
    <div className={isSharingModule ? classes.disableClick : ''}>
      {orgType === 'FF' && showDiscoverBuyRates && renderViewMode()}
      <Row
        className={classes.centerAlign}
        style={{
          margin: getDiscoverSearchBarMargin(isDiscoverPage, isLandingPage, mode, orgType),
          flexDirection: isLandingPage ? 'column' : 'row',
        }}
      >
        {renderMode()}
        {renderSearchBarFields()}
        {isLandingPage && renderIncludeExpiredRates()}
        {isLandingPage && renderChargesApplicableCard()}  
        {!isSharingModule && renderSearchButton()}
      </Row>
      <div
        className={classes.recentSearches}
        style={{
          margin: isDiscoverPage ? `28px ${mode === DOMESTIC ? '16%' : '11%'} 8px` : '12px 10% 0 40px',
          justifyContent: RecentSearchModeWiseLength ? 'space-between' : 'flex-end'
        }}
      >
        {localStorageSavedValues?.length > 1 && !isLandingPage && !isSharingModule
          ? renderRecentSearches()
          : ''}
        {!isLandingPage && renderChargesApplicableCard()}
        {isServicesFilterDetailsModalVisible && renderServicesFilterDetailsModal()} 
      </div>
    </div>
  );
};

const mapStateToProps = ({ masterData, discoverRatesReducer, inquiryReducer, rateMasterReducer }, ownProps) => ({
  containerList: masterData.containerList,
  cargoList: masterData.cargoList,
  cargoTypeList: masterData.cargoTypeList,
  searchFilters: discoverRatesReducer.searchFilters,
  selectedFilters: discoverRatesReducer.selectedFilters,
  showDiscoverBuyRates: masterData.modules.show_discover_buy_rates,
  showDiscoverSellRates: masterData.modules.show_discover_sell_rates,
  orgType: masterData.userData.type,
  userRole: masterData.userData.role,
  viewType: discoverRatesReducer.searchFilters?.viewType,
  gridFreightRange: discoverRatesReducer.gridFreightRange,
  gridTransitRange: discoverRatesReducer.gridTransitRange,
  gridPorts: discoverRatesReducer.gridPorts,
  inquiryTypeToIncoterms: masterData?.inquiryTypeToIncoterms,
  fetchedFilters: discoverRatesReducer.fetchedFilters,
  discoverRatesMaps: masterData?.discoverRates ?? {},
  discoverRatesPrefillData: masterData?.redirectPrefillData,
  disableRateDiscoveryServicesLinking: masterData.modules.disable_rate_discovery_services_linking || false,
  stuffingAddressesList: discoverRatesReducer.stuffingAddressesList,
  destuffingAddressesList: discoverRatesReducer.destuffingAddressesList,
  defaultDistanceUnit: masterData?.inquiryDefaults?.defaultDistanceUnit,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setSearchFilterValues,
      fetchAllData,
      fetchGridData,
      getAllDataResetFilter,
      getAllDataSetSortByFilter,
      getAllDataSetFilter,
      setGridFiltersRange,
    },
    dispatch
  );

const DiscoverRateSearchBarStyled = withStyles(DiscoverRatesSearchBarStyles)(
  Form.create()(DiscoverRateSearchBar)
);
export default withRateDigitisationMasterData(
  connect(mapStateToProps, mapDispatchToProps)(DiscoverRateSearchBarStyled)
);
